<template>
  <div id="header-logo">
    <img v-if="isMobile" src="@/assets/header-logo-icon.png" alt="美团骑行合作商平台" />
    <img v-else src="@/assets/header-logo.png" alt="美团骑行合作商平台" />
  </div>
</template>

<script>
import { userAgent } from '@bike/fe-utils'

export default {
  name: 'HeaderLogo',
  computed: {
    isMobile() {
      return userAgent.isMobile()
    },
  },
}
</script>

<style scoped lang="scss">
#header-logo {
  padding-left: 20px;
  display: flex;
  flex: auto;
  align-items: center;

  > img {
    display: block;
    height: 32px;
  }
}
</style>
